module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0046.jpg?v=470e1e15";